import React, { useState } from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./Returns.css";

const Returns = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    { q: "How long do I have to return an item?", a: "You have 7 days from the date of delivery to initiate a return for most items. Perishable goods and customized products are not eligible for return." },
    { q: "What condition must the item be in for a return?", a: "Items must be unused, in their original packaging, and in the same condition you received them. Any item not in its original condition or damaged due to customer use will not be accepted." },
    { q: "How do I initiate a return?", a: "Log in to your account, go to 'My Orders', select the item you wish to return, and click 'Request Return'. Our team will review and respond within 24 hours." },
    { q: "When will I receive my refund?", a: "Once we receive and inspect your returned item, refunds are processed within 5–7 business days to your original payment method." },
    { q: "Who pays for return shipping?", a: "If the return is due to a defect or our error, we cover the return shipping cost. For other returns, the customer is responsible for return shipping fees." },
  ];

  const steps = [
    { icon: "fa fa-mouse-pointer", title: "Request Return", text: "Log in and go to My Orders to submit a return request." },
    { icon: "fa fa-check-square-o", title: "Get Approval", text: "Our team reviews your request and approves within 24 hours." },
    { icon: "fa fa-truck", title: "Ship the Item", text: "Pack the item securely and ship it using the provided instructions." },
    { icon: "fa fa-money", title: "Receive Refund", text: "Once received and inspected, your refund is processed in 5–7 days." },
  ];

  return (
    <div>
      <CartBannerComponent title="Returns" />
      <div className="container returns-container my-5">

        <div className="row mb-5">
          <div className="col-md-8 mx-auto text-center">
            <h2 className="section-title">Return & Refund Policy</h2>
            <p className="text-muted">We want you to be completely satisfied with your purchase. If something isn't right, we're here to help.</p>
          </div>
        </div>

        <div className="row mb-5">
          {steps.map((s, i) => (
            <div key={i} className="col-md-3 col-sm-6 mb-4 text-center">
              <div className="return-step p-4">
                <div className="step-icon mb-3"><i className={s.icon} /></div>
                <div className="step-num mb-2">Step {i + 1}</div>
                <h6 className="font-weight-bold">{s.title}</h6>
                <p className="text-muted small">{s.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="row mb-5">
          <div className="col-md-6 mb-4">
            <div className="policy-card p-4">
              <h5 className="font-weight-bold mb-3 text-success"><i className="fa fa-check-circle mr-2" />Eligible for Return</h5>
              <ul className="policy-list">
                <li>Items returned within 7 days of delivery</li>
                <li>Unused items in original packaging</li>
                <li>Defective or damaged items on arrival</li>
                <li>Wrong item delivered</li>
                <li>Items with original tags attached</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="policy-card p-4">
              <h5 className="font-weight-bold mb-3 text-danger"><i className="fa fa-times-circle mr-2" />Not Eligible for Return</h5>
              <ul className="policy-list">
                <li>Perishable goods (food, beverages)</li>
                <li>Customized or personalized items</li>
                <li>Items returned after 7 days</li>
                <li>Used or washed items</li>
                <li>Items without original packaging</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8 mx-auto">
            <h4 className="font-weight-bold mb-4 text-center">Frequently Asked Questions</h4>
            {faqs.map((faq, i) => (
              <div key={i} className="faq-item mb-3">
                <div className="faq-question d-flex justify-content-between align-items-center" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{faq.q}</span>
                  <i className={`fa ${openFaq === i ? "fa-minus" : "fa-plus"}`} />
                </div>
                {openFaq === i && (
                  <div className="faq-answer">{faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Returns;